/**
 * Componente RequireAdminAuth.
 *
 * Wrapper de rota: renderiza children só se houver login de admin/mediador
 * (senha → token estático ADMIN_TOKENS). Sem login → manda pro formulário de
 * senha em /admin/login. Clerk foi removido do projeto.
 *
 * Uso:
 *   <Route path="/admin">
 *     <RequireAdminAuth role="admin">
 *       <Admin />
 *     </RequireAdminAuth>
 *   </Route>
 */
import { type ReactNode } from "react";
import { Redirect } from "wouter";
import { isAdminLoggedIn, permitirAdminSemAuth } from "../lib/admin-auth";

type RequireAdminAuthProps = {
  /** Mantido por compat de API. A autorização por role é feita no BACKEND
   *  (cada endpoint exige admin|mediador via requer_admin_ou_mediador). */
  role?: "admin" | "mediador";
  children: ReactNode;
};

export default function RequireAdminAuth({ children }: RequireAdminAuthProps) {
  // 1. Login por senha já feito (token estático no localStorage). O backend
  //    revalida o token (ADMIN_TOKENS) em cada fetch.
  if (isAdminLoggedIn()) {
    return <>{children}</>;
  }

  // 2. Bypass dev (localhost / ?dev-admin=1 / env).
  if (permitirAdminSemAuth()) {
    return <>{children}</>;
  }

  // 3. Sem login → formulário de SENHA.
  const destino =
    typeof window !== "undefined" && window.location?.pathname
      ? window.location.pathname
      : "/admin/validacao";
  return <Redirect to={`/admin/login?redirect=${encodeURIComponent(destino)}`} />;
}
